import { createContext, createRef, RefObject } from "react";

interface TutorialRefs {
  helpButtonRef: RefObject<HTMLButtonElement>;
  newPentestButtonRef: RefObject<HTMLDivElement>;
  newPentestFormRef: RefObject<HTMLDivElement>;

  sidebarRef: RefObject<HTMLDivElement>;
  tokenBoxRef: RefObject<HTMLDivElement>;
  searchListRef: RefObject<HTMLButtonElement>;
  refreshListRef: RefObject<HTMLButtonElement>;
  toggleTokenRef: RefObject<HTMLButtonElement>;
  editorButtonRef: RefObject<HTMLButtonElement>;
  exportPdfRef: RefObject<HTMLButtonElement>;
}
interface TutorialStates {
  tutorialRefs: TutorialRefs;

  stepIndex: number;
  setStepIndex: (nr: number) => void;
  nextStep: () => void;
}

export const TutorialContext = createContext<TutorialStates>({
  tutorialRefs: {
    helpButtonRef: createRef(),
    newPentestButtonRef: createRef(),
    newPentestFormRef: createRef(),
    sidebarRef: createRef(),
    tokenBoxRef: createRef(),
    searchListRef: createRef(),
    refreshListRef: createRef(),
    toggleTokenRef: createRef(),
    editorButtonRef: createRef(),
    exportPdfRef: createRef(),
  },

  stepIndex: 0,
  setStepIndex: () => {},
  nextStep: () => {},
});
